import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './Client.css';

export const Client = () => {
  return (
    <div className="client-page">
      {/* Hero */}
      <section className="client-hero">
        <div className="container">
          <span className="badge">Our Clients</span>
          <h1>Partnerships That Drive Results</h1>
          <p>
            We are dedicated to delivering bespoke solutions that redefine industry standards.
          </p>
        </div>
      </section>

      {/* Featured Clients - Highlighted Section */}
      <section className="clients-showcase">
        <div className="container">
          <div className="section-header">
            <span className="badge">Trusted By Industry Leaders</span>
            <h2>Our Clients</h2>
            <p>Proud to partner with world-class organizations driving innovation.</p>
          </div>
          <div className="clients-logo-grid">
            <div className="client-logo-card">
              <div className="client-logo-glow"></div>
              <div className="client-logo-name">Deloitte</div>
              <div className="client-logo-divider"></div>
              <p className="client-logo-desc">Global Consulting & Advisory</p>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-glow"></div>
              <div className="client-logo-name">HP / Mphasis</div>
              <div className="client-logo-divider"></div>
              <p className="client-logo-desc">Enterprise Technology Services</p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="section">
        <div className="container">
          <div className="client-value">
            <div className="client-value-content">
              <h2>Strategic Partners in Your Growth</h2>
              <p>
                Our full-stack expertise, commitment to agility, and collaborative approach
                ensure tailor-made software, seamless integration, and comprehensive services.
                With a focus on your unique needs, we strive to be your strategic partner in
                unlocking unparalleled business potential.
              </p>
              <p>
                We offer scalability, cost-effectiveness, and innovative solutions for sustained
                success in the digital era. Every engagement begins with understanding your
                business challenges and ends with measurable impact.
              </p>
              <div className="client-features">
                <div className="client-feature">
                  <h4>Full-Stack Expertise</h4>
                  <p>End-to-end technical capabilities across modern platforms</p>
                </div>
                <div className="client-feature">
                  <h4>Agile Delivery</h4>
                  <p>Iterative development with continuous feedback loops</p>
                </div>
                <div className="client-feature">
                  <h4>Scalable Solutions</h4>
                  <p>Architecture built to grow with your business</p>
                </div>
                <div className="client-feature">
                  <h4>Cost-Effective</h4>
                  <p>Optimized resource utilization and strategic planning</p>
                </div>
              </div>
              <NavLink to="/contact" className="btn btn-primary">
                Work With Us <FaArrowRight />
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
